// @ts-nocheck
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { DashboardScreen } from '../screens/Dashboard';
import { LandingScreen } from '../screens/LandingPage';
import { LoginScreen } from '../screens/Login';
import { RegistrationScreen } from '../screens/Registration';
import { ForgotPasswordScreen } from '../screens/ForgotPassword';
import { ResetPasswordScreen } from '../screens/ResetPassword';
import { ProductScreen } from '../screens/ProductView';
import { ProvenanceMapModal, ProductInfoScreen, ProductDetails } from '../screens/ProductView/components';
import { FeedbackScreenView } from '../screens/FeedbackScreen';
import { PromoEnrollScreen } from '../screens/PromoEnrollView';
import { NotFoundScreen } from '../screens/PageNotFound';
import { FabProductInfoScreen } from '../screens/FabProductInfo';
import { TermsandConditionScreen } from '../screens/TermsAndCondition';
import { PrivacyScreen } from '../screens/PrivacyPolicy';
import { VerifyUserScreen } from '../screens/VerifyUser';
import {VerifierScreen} from '../screens/VerifierView'
import { BrowserRouter as Router, Switch, Route, Link, Redirect } from 'react-router-dom';

import { useAuth } from '../services/auth-service/auth.provider';

const { isAuthenticated } = useAuth();

const RouterConfig = props => (
  <Switch>
    <PrivateRoute path="/dashboard" component={DashboardScreen} />
    <Route path="/login" component={LoginScreen} />
    <Route path="/register" component={RegistrationScreen} />
    <Route path="/forgotpassword" component={ForgotPasswordScreen} />
    <Route path="/resetpassword" component={ResetPasswordScreen} />
    <Route path="/map" component={ProvenanceMapModal} />
    <Route path="/info" component={ProductInfoScreen} />
    <Route path="/productDetail" component={ProductDetails} />
    <Route path="/detailedInfo" component={FabProductInfoScreen} />
    <Route path="/feedback" component={FeedbackScreenView} />
    <Route path="/requestPromo" component={PromoEnrollScreen} />
    <Route path="/hello" component={NotFoundScreen} />
    <Route path="/termsandcondition" component={TermsandConditionScreen} />
    <Route path="/privacy" component={PrivacyScreen} />
    <Route path="/provenance" component={ProductScreen} />
    <Route path="/verifyemail" component={VerifyUserScreen} />
    <Route path="/credential" component={VerifierScreen} />
    <Route path="/" component={LandingScreen} />
  </Switch>
);

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
          <Redirect
            to={{
              pathname: '/',
            }}
          />
        )
    }
  />
);

function RouteWithSubRoutes(route) {
  return (
    <Route
      path={route.path}
      render={props => (
        // pass the sub-routes down to keep nesting
        <route.component {...props} routes={route.routes} />
      )}
    />
  );
}

const Stack = createStackNavigator();

const AppNavigatorInternal = (): JSX.Element => {
  return (
    <NavigationContainer>
      <Stack.Navigator headerMode={'none'}>
        <Stack.Screen name="Dashboard" component={DashboardScreen} />
      </Stack.Navigator>
    </NavigationContainer>
  );
}

export const AppNavigator = (): JSX.Element => {
  return (
    <Router>
      <RouterConfig />
    </Router>
  );
};
